module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('image', {
    style: {
      'border-radius': _vm.radius,
      'width': _vm.width,
      'height': _vm.height
    },
    attrs: {
      "src": _vm.imagePath,
      "placeholder": _vm.placeholderPath,
      "resize": _vm.resize
    },
    on: {
      "click": function($event) {
        _vm._click($event)
      },
      "load": function($event) {
        _vm._load()
      }
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-5fd020f8!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-image/index.vue
// module id = 630
// module chunks = 0 1